import { render } from "./RelationTable.vue?vue&type=template&id=c3bcfc6e"
import script from "./RelationTable.vue?vue&type=script&lang=js"
export * from "./RelationTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__